import styled from "@emotion/styled";

export const ContactUsPage = styled.main`
  margin-top: 80px;
  .infoSection {
    margin-bottom: 100px;
  }
  .text {
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    color: #808285;
    margin-bottom: 40px;
  }
  .title {
    font-weight: 500;
    font-size: 20px;
    line-height: 35px;
    color: #000000;
    margin-bottom: 30px;
  }
  .infoWrapper {
    margin-bottom: 30px;
    &:last-of-type {
      margin-bottom: 0;
    }
    max-width: 480px;
    .location {
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #808285;
      margin-bottom: 8px;
    }
  }
  i {
    display: flex;
    margin-right: 8px;
    margin-top: 5px;
  }
  li {
    display: flex;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 30px;
    color: #000000;
    span {
      display: flex;
      span {
        direction: initial;
      }
    }
  }
  button {
    padding: 9px 45px;
    border-radius: 74px;
  }
  .formWrapper {
    position: relative;
  }
  .MuiInputBase-root {
    margin-bottom: 30px;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      ".infoWrapper": {
        maxWidth: "100%",
      },
    },
  })}
`;

export const MapWrapper = styled.div`
  margin-bottom: -6px;
  #google-map {
    width: 100%;
    height: 500px;
  }
  iframe {
    border: 0;
    width: 100%;
    margin: 0;
    height: 500px;
  }
`;
